// src/theme/components/kbd.js
// macOS / Linear tarzi Kbd · ince, monospaced, iki katmanli gölge.
// <Kbd>⌘</Kbd><Kbd>K</Kbd> gibi kullanimlar icin.

const Kbd = {
  baseStyle: {
    bg: 'bgSecondary',
    color: 'textSecondary',
    borderWidth: '1px',
    borderColor: 'borderPrimary',
    borderBottomWidth: '2px',
    borderRadius: 'md',
    fontFamily: 'mono',
    fontSize: 'xs',
    fontWeight: 'semibold',
    px: 1.5,
    py: 0.5,
    minW: '1.5em',
    textAlign: 'center',
    lineHeight: 'ui',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: 'xs',
    userSelect: 'none',
  },
};

export default Kbd;
